export default __webpack_public_path__ + "static/media/galerie9.8da5b86c.jpg";